import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Phone } from 'lucide-react';
import { Button } from '../ui/button';

export default function HomeCtaSection() {
  return (
    <section className="py-20 bg-gradient-to-r from-[#111111] to-[#1F1F1F] border-t border-[#C9A24D]/10">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl text-center">
        <h2 className="font-['Playfair_Display'] text-3xl sm:text-4xl font-bold text-[#F5F5F5] mb-4">
          Prêt à voyager en toute sérénité ?
        </h2>
        <p className="text-[#A7A7A7] text-base mb-8">
          Que ce soit pour un transfert aéroport, une excursion en Normandie ou un déplacement professionnel, notre équipe
          organise vos trajets au départ du Havre avec des chauffeurs expérimentés et une flotte premium.
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <Link to="/booking">
            <Button className="bg-[#C9A24D] hover:bg-[#E6C77A] text-[#050509] font-semibold px-8 py-3 rounded-none text-base">
              <Calendar className="w-5 h-5 mr-2" />
              Réserver en ligne
            </Button>
          </Link>
          <a href="tel:+33278780404">
            <Button
              variant="outline"
              className="border-[#F5F5F5]/40 text-[#F5F5F5] hover:bg-[#F5F5F5]/10 px-8 py-3 rounded-none text-base"
            >
              <Phone className="w-5 h-5 mr-2" />
              Parler à un conseiller
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
}
